const ko = {
    name: '이름',
    category: '카테고리',
    addProduct: '새로운 제품 추가',
    plCode: '분류코드를 입력해주세요',
    plName: '카테고리 이름을 입력하세요',
    selCategory: '제품 카테고리를 선택해주세요',
    code: '인코딩',
    addCategory: '새로운 카테고리 추가',
    addSubCategory: '새로운 하위 카테고리 추가',
    noDelTips1: '이 카테고리에는 제품이 있으므로 삭제할 수 없습니다. ',
    tips: '팁',
    conTips: '이 카테고리를 삭제하시겠습니까? ',
    noDelTips2: '이 카테고리에는 하위 카테고리가 있어 삭제할 수 없습니다. ',
    plEnterName: '카테고리 이름을 입력하세요',
    productList: '제품 목록',
    delCategory: '카테고리 삭제',
    plSearch:'검색할 키워드를 입력하세요',
    fetchFail: '제품 카테고리 쿼리가 실패했습니다',

    storeType: '재고 유형:',
    storeTypeCloumn:'재고 유형',
    storeTypeNum: '수량',
    storeTypeCode: '바코드',
    hsCode: 'HS 코드',
    plHsCode: 'HS코드를 입력해주세요',
    plChooseType: '유형 선택',
    all: '모두',
  setCategoryOrg: '카테고리 관리 부서 설정'
};

export default ko;